module.exports = __webpack_public_path__ + "media/categories/2033-1d7dfc3b.svg";